import { createFileRoute, getRouteApi, notFound, redirect } from '@tanstack/react-router'
import { DeviceNotFound } from '../../components/errors/NotFound.tsx'
import { accumulationResetTimesQuery } from '../../data/accumulationResetTimes.ts'
import { deviceListQuery } from '../../data/devices.ts'
import { DeviceForm } from '../../features/devices/DeviceForm.tsx'
import { useRequiredDevice } from '../../features/devices/utils.ts'

export const Route = createFileRoute('/_app/devices/$id_/edit')({
	component: RouteComponent,
	notFoundComponent: () => <DeviceNotFound redirectTo='/devices' />,
	beforeLoad: ({ context: { sub, isAdmin, impersonation } }) => {
		const canManageDevices = sub.features.includes('manage-devices')
		if (!isAdmin || (!impersonation && !canManageDevices)) {
			throw redirect({ to: '/devices' })
		}
	},
	loader: async ({ context: { queryClient, impersonation }, params }) => {
		const [devices] = await Promise.all([
			queryClient.ensureQueryData(deviceListQuery(impersonation?.partyAccountId)),
			queryClient.ensureQueryData(accumulationResetTimesQuery(impersonation?.partyAccountId)).catch(console.error),
		])
		if (!devices.some((device) => device.id === params.id)) {
			throw notFound()
		}
	},
})

const route = getRouteApi('/_app/devices/$id_/edit')

function RouteComponent() {
	const { id } = route.useParams()
	const device = useRequiredDevice(id)
	return <DeviceForm editDevice={device} />
}
